import React from 'react';
import { Link } from 'react-router-dom';
import { openGlobalCookieSettingsModal } from '../CookieBanner'; // + Import the function
import '../../styles/Footer.css'; // Import Footer CSS

const Footer = (): React.ReactElement => {  
  return (    <footer className="foo-footer">
      <div className="foo-footer-content container">
        <div className="foo-footer-section">
          <h3>BodySharing</h3>
          <p>© {new Date().getFullYear()} BodySharing. All Rights Reserved.</p>
        </div>
        
        <div className="foo-footer-section">
          <h3>Legal</h3>
          <ul className="foo-footer-links">
            <li><Link to="/datenschutz">Datenschutzerklärung</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li> 
              <button onClick={() => openGlobalCookieSettingsModal()} className="foo-footer-link-button">Cookie Settings</button>
            </li>
          </ul>
        </div>
        
        <div className="foo-footer-section">
          <h3>Contact</h3>
          <ul className="foo-footer-links">
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

// Add some basic styling for the button in Footer.css or a global css.
// For now, let's assume it will inherit button styles or we add a specific class.
// We can create/append to Footer.css if specific styles are needed.
// Example style for .cookie-settings-button (can be added to Footer.css or global.css):
/*
.cookie-settings-button {
  background: none;
  border: none;
  color: var(--text-color); // Or your link color
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit; // Inherit font size from parent
}

.cookie-settings-button:hover {
  color: var(--accent-color); // Or your link hover color
}
*/
export default Footer;
